import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { IDistrict } from '../interfaces/district.interface';

export class DistrictModel extends BaseModel implements IDistrict {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  postalSector!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;
}
